module.exports = __webpack_public_path__ + "media/images/map_icons/Rowing-0fc6be6a988ac06c39c63f214376ae77.svg";